import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit'
import { accountsApi, leveragesApi } from '../api/leveragesApi'

import { RootState } from 'app/AppStore'

import { isFetchBaseQueryError } from 'shared/api'

import { toast } from 'react-toastify'

import { symbols } from 'mock/symbols'
import { groupedSymbols } from '../helpers/helpers'
import { AccountData } from '../api/types'
import { priceToView } from 'shared/utils/format/currency'

type leveragesSliceState =
  | {
      list: string[]
    }
  | {
      list: string[]
    }

const initialState: leveragesSliceState = {
  list: [],
}

export const leveragesSlice = createSlice({
  name: 'leverages',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(
      leveragesApi.endpoints.leverages.matchFulfilled,
      (state, { payload }) => {
        state.list = payload
      },
    )
  },
})

export const selectLevaragesList = (state: RootState): AccountData[] =>
  state.leverages.list

export const leveragesSelector = createSelector(
  [selectLevaragesList],
  list => list,
)

export const dropdownLeveragesSelector = createSelector(
  [selectLevaragesList],
  list =>
    list?.map(item => ({
      label: item.title,
      value: item.value,
    })),
)
